import React from 'react'
import Link from 'gatsby-link'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Divider from '@material-ui/core/Divider'

let fbImage = require('../../src/assets/social-networks/facebook.png')
let belgranoImg = require('../../src/assets/img/manuel-belgrano.jpg')
let frondiziImg = require('../../src/assets/img/entrevista-frondizi-guevara-mn.jpg')
let FaArrowAltCircleRight = require('../../src/assets/img/arrowright2.png')

const styles = (theme) => ({
  container: {
    backgroundColor: 'red',
  },
  containerFooter2: {
    display: 'flex',
    backgroundColor: '#1D1D1D',
    justifyContent: 'space-around',
    alignItems: 'center',
    height: '3rem',
  },
  containerFooter: {
    backgroundColor: '#333',
    textAlign: 'center',
    fontSize: 12,
    //paddingTop: 6,
    display: 'flex',
    flexDirection: 'column',
  },
  copyRight: {
    width: 400,
    margin: 0,
    padding: 0,
    color: '#787878',
    fontSize: 13,
  },
  imgFb: {
    margin: 0,
    width: 30,
    height: 30,
    opacity: '0.7',
  },
  imgContainer: {
    paddingTop: 5,
  },
  typoFontTitle: {
    color: '#A4A4A4',
  },
  typoFontA: {
    color: '#DBDBDB',
    fontSize: '0.9rem',
    margin: 5,
  },
  typoFontB: {
    color: '#DBDBDB',
    fontSize: '0.8rem',
    margin: 5,
    display: 'flex',
    justifyContent: 'center',
  },
  typoFontC: {
    color: '#DBDBDB',
    fontSize: '0.7rem',
    margin: 5,
    maxWidth: '11rem',
  },
  dividerContStyle: {
    backgroundColor: '#9E9E9E',
    opacity: '0.3',
    marginLeft: '1rem'
  },
  dividerStyle: {
    backgroundColor: '#9E9E9E',
    opacity: '0.3',
  },
  dividerStyle3: {
    backgroundColor: '#9E9E9E',
    opacity: '0.3',
    width: '16rem',
  },
  dividerDestacadosStyle: {
    backgroundColor: '#9E9E9E',
    opacity: '0.3',
    marginLeft: 20
  },
  leftImage: {
    maxWidth: '3.5rem',
    margin: '0.15rem',
    border: '3px solid #444444'
  },
  arrowImageA: {
    margin: 3,
    marginRight: 14,
  },
  arrowImageB: {
    margin: 3,
    marginRight: 20,
  },
  arrowImageC: {
    margin: 3,
    marginRight: 7,
  },
})

let screen = (typeof window !== `undefined`) ? window.innerWidth : 1400;

let Footer = (props) => {
  return (
    <div className={props.classes.container}>
      <footer className={props.classes.containerFooter}>
        {/* <div style={{
          display: 'flex',
          backgroundColor: '#333333',
          justifyContent: 'space-around',
          height: (screen <= 480) ? '22.5rem' : '12.5rem',
        }}>
          <Grid container alignItems="center" justify='center'>
            <Grid item xs={12} sm={3} style={{
              marginBottom: (screen <= 480) ? '0' : '1.1rem',
            }}>
              <Typography variant="subheading" color='textPrimary'
                          className={props.classes.typoFontTitle}>Resúmenes</Typography>

              <Divider className={props.classes.dividerStyle}/>

              <Typography variant="body2" color='caption' className={props.classes.typoFontA}>
                Los mejores resúmenes para aprender de la forma más didáctica y
                divertida nuestra historia argentina, que es entretenida y emocionante.
              </Typography>
            </Grid>

            <Grid item xs={12} sm={3} style={{
              marginBottom: (screen <= 480) ? '0' : '0.5rem',
            }} >

              <Typography variant="subheading" color='textPrimary' className={props.classes.typoFontTitle}>Atajos
                rápidos</Typography>

              <Divider className={props.classes.dividerContStyle}/>

              <Link to={'/sucesos/revolucion-surgimiento-patria-criolla'}>
                <Typography variant="body2" color='caption' className={props.classes.typoFontB}>
                  <img src={FaArrowAltCircleRight} alt="" className={props.classes.arrowImageA} />
                  <p>Revolución de Mayo</p>
                </Typography>
              </Link>

              <Divider className={props.classes.dividerContStyle}/>

              <Link to={'/sucesos/autonomias-organizacion-nacional'}>
                <Typography variant="body2" color='caption' className={props.classes.typoFontB}>
                  <img src={FaArrowAltCircleRight} alt="" className={props.classes.arrowImageB} />
                  <p>Gobierno de Rosas</p>
                </Typography>
              </Link>

              <Divider className={props.classes.dividerContStyle}/>

              <Link to={'/sucesos/alternativa-autoritaria-2'}>
                <Typography variant="body2" color='caption' className={props.classes.typoFontB}>
                  <img src={FaArrowAltCircleRight} alt="" className={props.classes.arrowImageC} />
                  <p>Presidencias de Perón</p>
                </Typography>
              </Link>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography variant="subheading" color='textPrimary'
                          className={props.classes.typoFontTitle}>Personas y Hechos Destacados</Typography>
              <Divider className={props.classes.dividerDestacadosStyle}/>

              <Grid container >
                <Grid item xs={12} sm={12} alignItems="center" justify='center' style={{display: 'flex'}}>
                  <Link to={'#'} style={{display: 'contents'}}>
                    <img src={frondiziImg} alt="" className={props.classes.leftImage}/>
                    <Typography variant="body2" color='caption' className={props.classes.typoFontC}>
                      En 1961: entrevista entre Frondizi y "Che" Guevara.
                    </Typography>
                  </Link>
                </Grid>

                <Grid item xs={12} sm={12} alignItems="center" justify='center' style={{display: 'flex'}}>
                  <Divider className={props.classes.dividerStyle3}/>
                </Grid>

                <Grid item xs={12} sm={12} alignItems="center" justify='center' style={{display: 'flex'}}>
                  <Link to={'#'} style={{display: 'contents'}}>
                    <img src={belgranoImg} alt="" className={props.classes.leftImage}/>
                    <Typography variant="body2" color='caption' className={props.classes.typoFontC}>
                      Belgrano: otro gran gestor de nuestra libertad.
                    </Typography>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div> */}
        <div className={props.classes.containerFooter2}>
          <p className={props.classes.copyRight}> © Copyright {new Date().getFullYear()} por Pablo Pivatto. Todos los
            derechos reservados.</p>
          <a href="https://www.facebook.com/historiArg1810/" target="_blank" className={props.classes.imgContainer}>
            <img className={props.classes.imgFb} src={fbImage} alt=""/>
          </a>
        </div>
      </footer>
    </div>)
}
//Footer = windowSize(Footer);
export default withStyles(styles)(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer.js